import { Avatar } from "@mui/material";
import { getInitials } from "helpers/utils";

import variables from "../../../assets/styles/_variables.module.scss";

interface IUserAvatar {
    name?: string;
    surname?: string;
    avatarUrl?: string;
    size?: "x-small" | "small" | "default";
}
const UserAvatar = ({ name, surname, avatarUrl, size = "default" }: IUserAvatar) => {
    const growStyle = {
        default: {
            height: "40px",
            fontSize: "14px",
        },
        small: {
            height: "34px",
            fontSize: "12px",
        },
        "x-small": {
            height: "30px",
            fontSize: "10px",
        },
    };

    const sx = {
        backgroundColor: variables["beneficiary-avatar-background"],
        color: variables["beneficiary-avatar-letter"],
        aspectRatio: "1/1",
        width: "auto",
    };

    return (
        <Avatar src={avatarUrl} sx={[sx, growStyle[size]]} imgProps={{ sx: { objectFit: "cover" } }}>
            {getInitials(`${name ?? ""} ${surname ?? ""}`)}
        </Avatar>
    );
};

export default UserAvatar;
